const financial = (x) => {
    return Number.parseFloat(x).toFixed(2);
};

const round2Fixed = (value) => {
    value = +value;

    if (isNaN(value)) return NaN;

    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[0] + 'e' + (value[1] ? +value[1] + 2 : 2)));

    // Shift back
    value = value.toString().split('e');

    //if( window.business && window.business.info && window.business.info.force_decimal && window.business.info.force_decimal == 1) {
    //    return (+(value[0] + 'e' + (value[1] ? (+value[1] - 2) : -2))).toFixed(2);
    //}
    return clean(
        (+(value[0] + 'e' + (value[1] ? +value[1] - 2 : -2))).toFixed(2),
    );
};

const clean = (value) => {
    let v;
    v = value.toString().replace('.00', '');
    v = v.toString().replace(',00', '');

    return v;
};

const convertToPrice = (p) => {
    //console.log('DEBUG DEBUG');
    //console.log(p);
    //console.log(typeof p);

    if (p === null) {
        return 0;
    }

    let price = p.toString().replace(',', '.');
    price = parseFloat(price);
    return price;
};

const trimPrice = (price) => {
    if (price > 99) {
        return parseInt(price);
    }
    return parseFloat(price, 1);
};

function roundDecimal(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

const max3digitsPrice = (p) => {
    if (p > 100) {
        p = Math.trunc(p);
        if (p > 1000) {
            p = p.toString();
            p = p.substr(0, 3);
            p = parseInt(p);
        }
    } else if (p > 0) {
        p = roundDecimal(p, 1);
        p = Number.parseFloat(p).toFixed(2);
        p = p.toString().replace('.00', '');
    }

    return p;
};

function round10(price) {
    //if( !pre) pre = 0;
    //var pow = Math.pow(10,pre);
    //return Math.round(num*pow)/pow;
    return Math.round(price / 10) * 10;
    //return Math.ceil(price / 10) * 10;
}

const formatPrice = (p, currentCurrency, originalCurrency) => {
    if (!currentCurrency) {
        return p;
    }
    let price = convertToPrice(p);
    //price = round2Fixed(price);
    price = financial(price);

    if (originalCurrency !== currentCurrency) {
        //https://trello.com/c/OG6j7zFy/943-souci-de-conversion-en-roubles
        //price = max3digitsPrice(price);
    }

    price = price.toString().replace('.00', '');
    price = price.toString().replace(',00', '');

    return price;
};

export { formatPrice, round2Fixed, clean, convertToPrice, trimPrice };
